import createSelector from 'web-app/util/custom-create-selector';
import RoutesMap from 'signin-app/routes/routes-map';
import { isPinApp } from 'signin-app/login/selectors';
import * as GroupsSelectors from 'signin-app/groups/selectors';
import * as GroupsHelpers from 'signin-app/groups/helpers';
import { relations, makeChildSelector, requirePickupInfo, getPinChild, isChildCheckedIn } from '../selectors';
export const getPickupPersonName = (state) => state.childCheckIn.pickupPersonName;
export const selectedPickupRelationId = (state) => state.childCheckIn.selectedPickupRelationId;
export const selectedHours = (state) => state.childCheckIn.selectedPickupHours;
export const selectedMinutes = (state) => state.childCheckIn.selectedPickupMinutes;
export const isCheckingIn = (state) => state.childCheckIn.isCheckingIn;
export const addingNewRelation = (state) => state.childCheckIn.addingNewRelation;
export const pickupPersonName = createSelector(relations, selectedPickupRelationId, getPickupPersonName, (childRelations, selectedPickupId, formPersonName) => {
    let pickupName;
    if (selectedPickupId) {
        const selectedPickupPerson = childRelations.find(relation => relation.relationId === selectedPickupId);
        pickupName = selectedPickupPerson ? selectedPickupPerson.name.firstName : '';
    }
    else {
        pickupName = formPersonName;
    }
    return pickupName;
});
const entityChildSelector = makeChildSelector(RoutesMap.childCheckIn);
export const child = createSelector(isPinApp, getPinChild, entityChildSelector, (pinApp, pinChild, entityChild) => {
    if (pinApp) {
        return pinChild;
    }
    return entityChild;
});
/**
 * Whether the pickup requirement is satisfied. Requiring pickup info always demands a pickup
 * person; a pickup time is demanded only where the site collects one, since the time picker is
 * hidden otherwise and would leave nothing to satisfy the requirement with.
 */
export const isPickupFulfilled = ({ pickupRequired, hasExpectedPickupTime, personChosen, timeChosen, }) => {
    if (!pickupRequired) {
        return true;
    }
    return personChosen && (!hasExpectedPickupTime || timeChosen);
};
export const canCheckIn = createSelector(selectedPickupRelationId, selectedHours, selectedMinutes, requirePickupInfo, getPickupPersonName, GroupsSelectors.hasExpectedPickupTime, (relationId, hours, minutes, pickupRequired, pickupName, hasExpectedPickupTime) => isPickupFulfilled({
    pickupRequired,
    hasExpectedPickupTime,
    personChosen: Boolean((pickupName && pickupName.length) || relationId.length > 0),
    timeChosen: hours !== undefined && minutes !== undefined,
}));
export const showPickupInfoScreen = createSelector(requirePickupInfo, isChildCheckedIn, (requirePickupInfo, isChildCheckedIn) => requirePickupInfo || !isChildCheckedIn);
export const pickupTimeOptions = createSelector(GroupsSelectors.openingHours, GroupsSelectors.timezone, (openingHours, timezone) => {
    return GroupsHelpers.timesLaterThanNow(openingHours, timezone);
});
